"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactTransitionGroup = require("react-transition-group");
var _tabbable = require("tabbable");
var _classnames4 = _interopRequireDefault(require("classnames"));
var _focusBoomerang = _interopRequireDefault(require("../../helpers/focus-boomerang"));
var _theme = require("../theme");
var _closeButton = _interopRequireDefault(require("./close-button"));
var _image = _interopRequireDefault(require("./image"));
var _sharedVariables = require("../../shared-variables");
require("./legacy-overlay.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } /* eslint-disable complexity */
/**
 * Creates a fixed position overlay with entrance and exit animation. There are two variants:
 *
 * Image Overlay: uses a built in image slot, which renders visually like a dialog in desktop
 * viewports. The image layout is handled automatically. This version is triggered by providing
 * an `imagePath` in the props.
 *
 * Standard Overlay: When not using the imagePath prop, the overlay simply renders its children.
 * In mobile viewports, the Overlay covers the entire screen. In desktop viewports, there are
 * configuration options for which part of the viewport to cover. Overlay uses the FocusBoomerang utility to manage
 * focus correctly when opened and closed; consumers will need to take care of preventing focus to
 * content covered by the Overlay.
 *
 * If the consumer can place the Overlay in a spot in the DOM which permits the fixed positioning
 * to work correctly, the Overlay may be used as is. If there are positioning or layering issues
 * due to being nested in a positioned element, the consumer may choose to use the `Layer`
 * component to facilitate positioning correctly.
 *
 * To get exit animation, the content/children of Overlay should be removed before the Overlay itself.
 * If the Overlay is able to be mounted at all times, entrance and exit animations will always work.
 */
var Overlay = /*#__PURE__*/function (_Component) {
  _inherits(Overlay, _Component);
  var _super = _createSuper(Overlay);
  function Overlay(props) {
    var _this;
    _classCallCheck(this, Overlay);
    _this = _super.call(this, props);
    _this.focusBoomerang = new _focusBoomerang["default"]();
    return _this;
  }
  _createClass(Overlay, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (!this.props.focusOnOpen) {
        return;
      }
      // Set focus after brief delay to allow the component to render first.
      setTimeout(function () {
        var container = _reactDom["default"].findDOMNode(_this2.$container);
        if (!container) {
          return;
        }
        // Elements that can only be set focus programmatically
        var firstFocusable = container.querySelectorAll('[tabIndex="-1"]')[0];
        var tabbableElements = (0, _tabbable.tabbable)(container);
        var firstTabbable = tabbableElements[0];
        if ((0, _get2["default"])(firstTabbable, 'dataset.isCloseButton', false) && tabbableElements.length > 1) {
          firstTabbable = tabbableElements[1];
        }
        _this2.focusBoomerang.check({
          wasActive: Boolean(prevProps.children),
          isActive: Boolean(_this2.props.children),
          // Set focus to the most appropriate item
          focusedWhenActive: firstFocusable || firstTabbable || container
        });
      }, 150);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      // eslint-disable-next-line no-console
      console.warn('Deprecation notice: This legacy version of the Overlay will be removed in an upcoming major version. Please update all Overlay usage to work with ModalProvider.');
      var _this$props = this.props,
        alignment = _this$props.alignment,
        children = _this$props.children,
        childrenContainerClassName = _this$props.childrenContainerClassName,
        className = _this$props.className,
        closeCallback = _this$props.closeCallback,
        closeProps = _this$props.closeProps,
        containerProps = _this$props.containerProps,
        imageAlt = _this$props.imageAlt,
        imageContainerProps = _this$props.imageContainerProps,
        imagePath = _this$props.imagePath,
        permitImageToShrink = _this$props.permitImageToShrink,
        imageObjectFit = _this$props.imageObjectFit,
        renderCloseButton = _this$props.renderCloseButton,
        showMask = _this$props.showMask,
        style = _this$props.style,
        topShadow = _this$props.topShadow;
      var isImageVariant = Boolean(imagePath);
      var maskClasses = 'sb-overlay__mask size12of12 height-100 bg-houseGreen visible';
      return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
        var themeClass = theme === _theme.themes.dark ? 'bg-houseGreen color-textWhite' : 'bg-white';
        var containerClasses = (0, _classnames4["default"])('visible', _defineProperty(_defineProperty({
          'sb-imageOverlay__container': isImageVariant,
          'sb-overlay__container': !isImageVariant,
          'sb-overlay--leftCrate': !isImageVariant && alignment === 'leftCrate',
          'sb-overlay--rightCrate': !isImageVariant && alignment === 'rightCrate',
          'sb-overlay--leftThird': !isImageVariant && alignment === 'leftThird',
          'sb-overlay--rightThird': !isImageVariant && alignment === 'rightThird',
          'sb-overlay--topShadow': topShadow
        }, themeClass, !isImageVariant), className, Boolean(className)));
        var contentClasses = (0, _classnames4["default"])('flex flex-column', _defineProperty(_defineProperty({
          'sb-overlay--heightLimit': permitImageToShrink,
          'sb-imageOverlay__content': isImageVariant
        }, themeClass, isImageVariant), 'sb-overlay__content', !isImageVariant));
        return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
          appear: true,
          component: null
        }, children ? /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
          classNames: "sb-overlay",
          timeout: {
            enter: parseInt(_sharedVariables.variables.defaultAnimationEntranceDuration, 10),
            exit: parseInt(_sharedVariables.variables.defaultAnimationExitDuration, 10)
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "sb-overlay__wrapper invisible",
          style: style
        }, showMask && /*#__PURE__*/_react["default"].createElement("div", {
          className: maskClasses,
          onClick: closeCallback
        }), /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: containerClasses,
          key: "container",
          ref: function ref(el) {
            return _this3.$container = el;
          },
          tabIndex: "-1"
        }, containerProps), /*#__PURE__*/_react["default"].createElement("div", {
          className: contentClasses,
          key: "content",
          style: permitImageToShrink ? {
            maxHeight: 'fit-content'
          } : {}
        }, renderCloseButton && /*#__PURE__*/_react["default"].createElement(_closeButton["default"], {
          closeCallback: closeCallback,
          closeProps: closeProps,
          isImageVariant: isImageVariant
        }), isImageVariant && /*#__PURE__*/_react["default"].createElement(_image["default"], {
          alt: imageAlt,
          containerProps: imageContainerProps,
          objectFit: imageObjectFit,
          permitToShrink: permitImageToShrink,
          src: imagePath
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames4["default"])('flex-grow', _defineProperty({
            'flex-shrink-none': permitImageToShrink
          }, childrenContainerClassName, Boolean(childrenContainerClassName)))
        }, children))))) : null);
      });
    }
  }]);
  return Overlay;
}(_react.Component);
Overlay.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Indicates what portion of the UI is covered in desktop viewports. Only applicable
   * when not using the imagePath option.
   */
  alignment: _propTypes["default"].oneOf(['fullscreen', 'rightCrate', 'leftCrate', 'rightThird', 'leftThird']).isRequired,
  /**
   * Nested component(s) which become the content of the overlay.
   */
  children: _propTypes["default"].any,
  /**
   * Classname passed to the element that wraps the children
   */
  childrenContainerClassName: _propTypes["default"].string,
  /**
   * Function attached to the click event of the included close button.
   */
  closeCallback: _propTypes["default"].func,
  /**
   * Props passed to the CloseButton component within the Overlay.
   */
  closeProps: _propTypes["default"].object,
  /**
   * Additional props to be spread on the container HTMLElement.
   */
  containerProps: _propTypes["default"].object,
  /**
   * When true, focus will be placed on the container div of the overlay when opened, permitting
   * seamless keyboard traversal. When false, the consumer is expected to manage focus.
   */
  focusOnOpen: _propTypes["default"].bool.isRequired,
  /**
   * Prop to allow for giving alternate text to the image
   */
  imageAlt: _propTypes["default"].string,
  /**
   * Props to pass into the container around the image
   */
  imageContainerProps: _propTypes["default"].object,
  /**
   * Optional prop to allow for image to be placed on top of the Overlay.
   */
  imagePath: _propTypes["default"].string,
  /**
   * Optional prop to allow for a top-image to be responsive. This is useful when you have tall content and a scalable image. Only applicable if imagePath is passed.
   */
  permitImageToShrink: _propTypes["default"].bool,
  /**
   * Optional prop to control the object-fit of the top image. Only applicable if imagePath is passed and permitImageToShrink is true.
   */
  imageObjectFit: _propTypes["default"].oneOf(['cover', 'contain', 'fill', 'scale-down']),
  /**
   * Whether to use the included default CloseButton component. If false, consumer is expected to
   * provide a custom close button in the children.
   */
  renderCloseButton: _propTypes["default"].bool.isRequired,
  /**
   * Whether to show a mask when the overlay is opened.
   */
  showMask: _propTypes["default"].bool,
  /**
   * Optional style object for custom styling such as z-index; applied to the outermost div.
   */
  style: _propTypes["default"].object,
  /**
   * A CSS box shadow intended for situations in which another container is visually 'above' the
   * overlay.
   */
  topShadow: _propTypes["default"].bool.isRequired
} : {};
Overlay.defaultProps = {
  alignment: 'rightCrate',
  closeCallback: function closeCallback() {},
  closeProps: {},
  focusOnOpen: true,
  imageAlt: ' ',
  imageObjectFit: 'cover',
  renderCloseButton: true,
  showMask: true,
  topShadow: false
};
var _default = exports["default"] = Overlay;